/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IDropdownStyles, IStackTokens, ITextStyles } from "@fluentui/react";

/**
 * Tokens for the approval form/data stack
 */
export const approvalFromStackTokens: IStackTokens = { childrenGap: 5 };

/**
 * Styling for the data and form labels
 */
export const labelTextStyles: ITextStyles = {
  root: {
    minWidth: 200,
  },
};

/**
 * Styling for the approval drop down selector
 */
export const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: 200,
    marginLeft: 0,
    marginRight: 10,
  },
};

/**
 * Styling for the comment textarea
 */
export const commentStyles = {
  flexGrow: 2,
  marginRight: 16,
};
